<template>
  <font-awesome-icon
      :icon="icon"
  />
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faSort, faSortUp, faSortDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

library.add(faSort, faSortUp, faSortDown);

export default {
  name: 'SortIcon',
  components: {
    FontAwesomeIcon
  },
  props: {
    type: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    current: {
      type: String,
      required: false
    }
  },
  computed: {
    icon() {
      if (this.type && this.current === this.name) {
        return 'sort-' + (this.type.toLowerCase() === 'asc' ? 'up' : 'down');
      }
      return 'sort';
    }
  }
};
</script>
